import { render } from "./TemplatePreviewPane.vue?vue&type=template&id=7a8052c3&scoped=true"
import script from "./TemplatePreviewPane.vue?vue&type=script&lang=js"
export * from "./TemplatePreviewPane.vue?vue&type=script&lang=js"

import "./TemplatePreviewPane.vue?vue&type=style&index=0&id=7a8052c3&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8052c3"]])

export default __exports__